import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { BaseComponent } from "src/app/secondadmin/base.component";
import { ClientService } from "src/app/services/clients/client.service";
import { MasterService } from "src/app/services/master/master.service";

@Component({
  selector: "app-edit-subscription-feature",
  templateUrl: "./edit-subscription-feature.component.html",
  styleUrls: ["./edit-subscription-feature.component.css"],
})
export class EditSubscriptionFeatureComponent extends BaseComponent implements OnInit {
  customer_id;
  updateFeatureForm: FormGroup;
  getCompanyobj: any = [];
  submitted = false;
  feature_id: string;
  selectedCompany: string;
  featureObj: any;
  subsObj: any = [];
  selectedSubs: any = [];
  featureValues: any = {};
  constructor(
    private formBuilder: FormBuilder,
    private clientsService: ClientService,
    private masterService: MasterService
  ) {
    super();
  }

  ngOnInit(): void {
    this.customer_id = JSON.parse(
      sessionStorage.getItem("userData")
    ).admin_customer_id;
    if (this.customer_id == 0) this.getCompany();
    this.updateFeatureForm = this.formBuilder.group({
      feature_name: ["", [Validators.required, Validators.maxLength(100)]],
      feature_slug: ["", [Validators.maxLength(100)]],
      feature_type: ["boolean", Validators.required],
      feature_desc: [""],
      order_no: [""],
      selectedCompany: [
        this.customer_id == 0 ? "" : this.customer_id,
        Validators.required,
      ]
    });
    if (localStorage.getItem("edit_subscription_feature_id")) {
      this.feature_id = localStorage.getItem("edit_subscription_feature_id");
      this.selectedCompany = localStorage.getItem(
        "edit_subscription_feature_company_id"
      );

      this.masterService
        .getSubscriptionFeatureById(this.selectedCompany, this.feature_id)
        .subscribe((response) => {
          if (response.status) {
            this.featureObj = response.data;
            this.dataBinding();
            this.loadSubscriptions(this.selectedCompany);
          }
        });
    }
  }

  dataBinding() {
    this.updateFeatureForm = this.formBuilder.group({
      feature_name: [this.featureObj?.feature_name, [Validators.required, Validators.maxLength(100)]],
      feature_slug: [this.featureObj?.feature_slug, [Validators.maxLength(100)]],
      feature_type: [this.featureObj?.feature_type || "boolean", Validators.required],
      feature_desc: [this.featureObj?.feature_desc || ""],
      order_no: [this.featureObj?.order_no],
      selectedCompany: [
        this.selectedCompany,
        Validators.required,
      ]
    });
    this.applyAssignments(this.featureObj && this.featureObj.assignments);
  }

  applyAssignments(assignments) {
    this.selectedSubs = [];
    this.featureValues = {};
    (assignments || []).forEach(item => {
      const id = Number(item.sub_id);
      this.selectedSubs.push(id);
      this.featureValues[id] = item.feature_value;
    });
  }

  loadSubscriptions(companyId?) {
    const company = companyId || this.updateFeatureForm.value.selectedCompany || this.selectedCompany;
    if (!company) {
      this.subsObj = [];
      return;
    }
    this.ngxSpinnerService.show();
    this.masterService.getSubscriptionListDropdown(company, 1000, 0).subscribe(data => {
      this.ngxSpinnerService.hide();
      if (data.status && data.data && data.data.rows) {
        this.subsObj = data.data.rows;
      } else {
        this.subsObj = [];
      }
    }, error => {
      console.log(error);
      this.subsObj = [];
      this.ngxSpinnerService.hide();
    });
  }

  isSubChecked(id) {
    return this.selectedSubs.indexOf(Number(id)) > -1;
  }
  defaultFeatureValue() {
    return this.updateFeatureForm.value.feature_type === "boolean" ? "true" : "";
  }
  toggleSub(id, checked) {
    id = Number(id);
    if (checked) {
      if (this.selectedSubs.indexOf(id) === -1) {
        this.selectedSubs.push(id);
      }
      if (!this.featureValues[id]) {
        this.featureValues[id] = this.defaultFeatureValue();
      }
    } else {
      this.selectedSubs = this.selectedSubs.filter(item => Number(item) !== id);
    }
  }
  buildAssignments() {
    return this.selectedSubs.map(id => {
      const value = (this.featureValues[id] || this.defaultFeatureValue() || "true").toString().trim();
      return { sub_id: Number(id), feature_value: value || "true" };
    });
  }

  getCompany() {
    let self = this;
    this.clientsService.getBUCompanies().subscribe(
      (data) => {
        self.getCompanyobj = data.data;
        self.hydrateWorkingCompany(self);

      },
      (error) => {
        console.log(error);
      }
    );
  }
  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || "").trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }
  get f() {
    return this.updateFeatureForm.controls;
  }
  updateFeatureData() {
    this.submitted = true;
    if (this.updateFeatureForm.invalid) {
      return;
    }
    let { selectedCompany } = this.updateFeatureForm.value;
    const body = Object.assign({}, this.updateFeatureForm.value, {
      assignments: this.buildAssignments()
    });
    this.masterService
      .updateSubscriptionFeature(selectedCompany, this.feature_id, body)
      .subscribe(
        (data) => {
          if (data.status) {
            this.toastrService.success("Subscription feature update successfully");
            this.router.navigateByUrl(`/corporate/subscription-feature-list`);
          } else {
            this.toastrService.error(data.message);
          }
        },
        (error) => {
          this.toastrService.error(error.message);
        }
      );
  }
}
